import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import crsl from "assets/logo/logo.svg";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/awards-and-recognitions", label: "Awards" },
  { to: "/channel-partners", label: "Partners" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <nav className={`csr-nav${scrolled ? " csr-nav--scrolled" : ""}`} aria-label="Main navigation">
      <div className="csr-nav__inner">

        {/* Brand */}
        <Link to="/" className="csr-nav__brand" onClick={() => setOpen(false)}>
          <img src={crsl} alt="CSR Associates Logo" className="csr-nav__logo" />
          <div className="csr-nav__brand-text">
            <span className="csr-nav__brand-name">CSR Associates</span>
            <span className="csr-nav__brand-tag">Debt Recovery · BPO · Karnataka</span>
          </div>
        </Link>

        {/* Desktop Links */}
        <ul className="csr-nav__links" role="list">
          {NAV_LINKS.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`csr-nav__link${location.pathname === to ? " csr-nav__link--active" : ""}`}
              >
                {label}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/contact" className="csr-nav__cta">
              Get in Touch
            </Link>
          </li>
        </ul>

        {/* Mobile hamburger */}
        <button
          className={`csr-nav__burger${open ? " open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`csr-nav__mobile${open ? " csr-nav__mobile--open" : ""}`}>
        {NAV_LINKS.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className={`csr-nav__mobile-link${location.pathname === to ? " active" : ""}`}
            onClick={() => setOpen(false)}
          >
            {label}
          </Link>
        ))}
        <Link to="/contact" className="csr-nav__mobile-cta" onClick={() => setOpen(false)}>
          Get in Touch
        </Link>
      </div>
    </nav>
  );
}
